import { render, staticRenderFns } from "./UserEditForm.vue?vue&type=template&id=6b36012f&scoped=true&"
import script from "./UserEditForm.vue?vue&type=script&lang=js&"
export * from "./UserEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UserEditForm.vue?vue&type=style&index=0&id=6b36012f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36012f",
  null
  
)

export default component.exports